import { ReactNode } from 'react';
import clsx from 'clsx';

import { Button } from '../../buttons/Button';
import { GoogleFontIcon } from '../../icons/GoogleFontIcon';

import styles from './navigationHeader.module.scss';

export type NavigationHeaderProps = {
  applicationSwitcher?: ReactNode;
  collapsed: boolean;
  userIcon?: ReactNode;
  zipUploadButton?: ReactNode;
  onCollapseClick?: () => void;
};

export function NavigationHeader({
  applicationSwitcher,
  collapsed,
  onCollapseClick,
  userIcon,
  zipUploadButton,
}: NavigationHeaderProps) {
  return (
    <div
      className={clsx(styles['root'], collapsed && styles['root--collapsed'])}
    >
      <div
        className={clsx(styles['logo'], collapsed && styles['logo--collapsed'])}
      ></div>
      <div className={clsx(styles['actions'])}>
        {!collapsed && (
          <div
            className={styles['actions-left']}
            data-testid="navigation-header-actions"
          >
            {userIcon}
            {applicationSwitcher}
            {zipUploadButton}
          </div>
        )}
        <Button
          variant="secondary"
          onClick={onCollapseClick}
          icon={
            collapsed ? (
              <GoogleFontIcon
                data-testid="navigation__button-expand"
                name="chevron_right"
              />
            ) : (
              <GoogleFontIcon
                data-testid="navigation__button-collapse"
                name="chevron_left"
              />
            )
          }
        />
      </div>
    </div>
  );
}
